<template>
    <validation-observer name="Customer" ref="validateSailing">
        <div class="sailing-schedule">
            <b-row class="flex justify-center items-center">
                <b-col>
                    <div class="title">Sailing Schedule</div>
                </b-col>
                <b-col>
                    <b-form-group class="flex justify-end">
                        <b-button
                            variant="primary"
                            type="button"
                            :disabled="readonly"
                            @click="modalSchedule = !modalSchedule"
                            class="customSchedule"
                        >
                            Select schedule
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-card class="b-card-bg">
                <b-col cols="12" lg="12">
                    <validation-provider
                        name="Cargo ready"
                        #default="{ errors }"
                        rules="required"
                    >
                        <b-form-group>
                            <label class="flex"
                                >Cargo ready <span class="red">*</span>
                            </label>
                            <b-row>
                                <b-col lg="8" class="pr-0">
                                    <date-picker
                                        :disabled="readonly"
                                        ref="datePicker"
                                        v-model="value.cargo_ready_date"
                                        type="date"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select date"
                                        format="DD/MM/YY"
                                        class="w-full"
                                        value-type="format"
                                    >
                                    </date-picker>
                                </b-col>
                                <b-col lg="4">
                                    <date-picker
                                        :disabled="readonly"
                                        v-model="value.cargo_ready_time"
                                        ref="datePicker"
                                        type="time"
                                        title-format="HH:mm"
                                        time-title-format="HH:mm"
                                        placeholder="Select time"
                                        format="HH:mm"
                                        class="w-full"
                                        value-type="format"
                                    >
                                    </date-picker>
                                </b-col>
                            </b-row>
                            <small
                                class="text-danger"
                                v-show="errors.length > 0"
                                >{{ errors[0] }}</small
                            >
                        </b-form-group>
                    </validation-provider>
                </b-col>
                <b-row class="px-1">
                    <b-col cols="12" lg="12">
                        <b-form-group>
                            <label>ETD</label>
                            <date-picker
                                :disabled="readonly"
                                v-model="value.etd"
                                ref="datePicker"
                                type="date"
                                title-format="DD/MM/YY"
                                time-title-format="DD/MM/YY"
                                placeholder="Select date"
                                format="DD/MM/YY"
                                class="w-full"
                                value-type="format"
                            >
                            </date-picker>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" lg="12">
                        <b-form-group>
                            <label>ETA</label>
                            <date-picker
                                :disabled="readonly"
                                v-model="value.eta"
                                ref="datePicker"
                                type="date"
                                title-format="DD/MM/YY"
                                time-title-format="DD/MM/YY"
                                placeholder="Select date"
                                format="DD/MM/YY"
                                class="w-full border-none"
                                value-type="format"
                            >
                            </date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
            <SelectSchedule
                v-if="modalSchedule"
                v-model="modalSchedule"
                @select="onSelectSchedule"
                :options="{
                    service:
                        $Utils.CONSTANTS.SERVICE_TYPE_ID[value.service_type] ||
                        '',
                    pol_name: this.value.pol_name,
                    pod_name: this.value.pod_name,
                    pol: this.value.pol_port,
                    pod: this.value.pod_port,
                    cargo_ready: this.value.cargo_ready,
                }"
            />
        </div>
    </validation-observer>
</template>

<script>
import Select2 from "v-select2-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import {
    BFormDatepicker,
    BFormGroup,
    BButton,
    BCol,
    BTable,
    BCard,
} from "bootstrap-vue";
export default {
    components: {
        Select2,
        ValidationProvider,
        ValidationObserver,
        BFormDatepicker,
        BFormGroup,
        BButton,
        BCol,
        BTable,
        BCard,
    },
    props: {
        value: {
            type: Object,
        },
        cargo_ready_date: null,
        cargo_ready_time: null,
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            R: true,
            modalSchedule: false,
        };
    },
    computed: {
        ...mapState("masterData", [
            "service_types",
            "ports",
            "incoterms",
            "cont_types",
            "goods_types",
            "transport_types",
            "deports_locations",
            "deports",
            "business_types",
            "customs_types",
            "shipping_lines",
            "regions",
            "companyItems",
            "fee_types",
            "handed_types",
        ]),
    },
    methods: {
        onSelectSchedule(e) {
            // console.log(e)

            this.value.vessel_name = e.load_vessel;
            this.value.shipping_line = e.carrier_id;
            this.value.place_of_stuffing = e.stuffing_place_id;
            this.value.eta = e.eta;
            this.value.etd = e.etd;
            this.value.contact = e.contact;
            this.value.closing_time = e.cargo_cut_off;
            this.value.cut_si_vgm = e.doc_cut_off;
            this.value.pod_port = e.pod_code;
            this.value.pol_port = e.pol_code;
            this.value.pol_name = e.pol;
            this.value.pod_name = e.pod;

            this.modalSchedule = false;
        },
    },
    watch: {
        "value.cargo_ready_date": function (n, o) {
            this.value.cargo_ready = n + " " + this.value.cargo_ready_time;
        },
        "value.cargo_ready_time": function (n, o) {
            this.value.cargo_ready = this.value.cargo_ready_date + " " + n;
        },
    },
};
</script>

<style lang="scss">
.sailing-schedule {
    .justify-end {
        justify-content: end;
    }
    label {
        color: #000000;
        font-weight: 600;
    }
    .b-card-bg {
        height: 300px;
    }
    .form-control {
        border: none !important;
    }
    .mx-input {
        border: none !important;
    }
    .customSchedule {
        padding: 10px 20px;
    }
}
</style>
